import { Component, Input } from '@angular/core';
import { IOrder } from '../../services/sale.service';

@Component({
  selector: 'order-number-header',
  templateUrl: './order-number-header.component.html',
  styleUrls: ['./order-number-header.component.scss'],
})
export class OrderNumberHeaderComponent {
  @Input() order: IOrder;

  public get orderId() {
    if (this.order) {
      return this.order.isRetail ? this.order.saleChId : this.order.orderId;
    } else {
      return '';
    }
  }
}
